export default "__VITE_ASSET__Ds6fOTT0__"